import * as yup from "yup"
import type { Faq } from "../../types"

export function initialValuesFaq(faq?: Faq | undefined) {
  if (faq) {
    return faq
  }
  return {
    answer: "",
    question: "",
    order: 0,
  }
}

export function validationSchemaFaq() {
  return yup.object().shape({
    question: yup.string().required("La domanda è obbligatoria"),
    answer: yup.string().required("La risposta è obbligatoria"),
  })
}
